import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class DrivingLicenseState extends _BaseUserProfile {
  component = 'DrivingLicenseStateForm';
  props = {
    title: 'State of Driver’s License Issuance:',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
  };
}
